import { useEffect, useState } from 'react'

const useGetLocation = () => {
    const [location, setLocation] = useState<{ latitude: number, longitude: number } | null | undefined>(null);
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false); 

    const getLocation = () => {
        setIsLoading(true)
        if (!navigator.geolocation) {
            setError('Geolocalização não é suportada pelo seu navegador');
            setIsLoading(false)
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
                setIsLoading(false)
            },
            (err) => {
                setError('Permissão negada ou erro ao acessar a localização');
                setLocation(undefined)
                setIsLoading(false)
            }
        );
    }

    useEffect(() => {
        getLocation()
    }, []);


    return { location, error, getLocation, isLoading }
}

export { useGetLocation }